
import AppEditBank from "@/components/bank/BankEdit.vue";
import { Bank } from "@/models/base";
import { BankService } from "@/services/bank-service";
import { ToolbarService } from "@/services/toolbar-service";
import Vue from "vue";
import { checkHasModule } from "../../router";
import { MODULE } from "../../config/modules";
import { TranslateResult } from "vue-i18n";
import {DossierConfigService} from "@/services";

export default Vue.extend({
	data() {
		return {
			booking: new Bank(),
			ready: false
		};
	},
	computed: {
		title():TranslateResult{
			return ToolbarService.title;
		},
	},
	methods: {
		onBankSave(bank: Bank) {
			this.booking = bank;
			this.$emit("created-new-bank", bank);
		},
		updateView() {
			this.$emit("update");
		},
		close() {
			this.$router.push("/bank");
		},
	},
	async mounted() {
		let id = parseInt(this.$route.params.id);

		if (id) {
			ToolbarService.title = this.$ct("edit-bank");
			this.booking = await BankService.getBooking(id);
		} else {
			ToolbarService.title = this.$ct("new-bank");
			this.booking.TypeID = DossierConfigService.getGeneralConfig().DefaultBankTypeID || BankService.getTypes()[0].ID;
			if(this.$route.query.typeId){
				let bankId = parseInt((this.$route.query.typeId as string) || "1") || 1;
				this.booking.TypeID = bankId;
			}
		}
		this.ready = true;
	},
	created(){
		if (!checkHasModule(MODULE.BANKGEGEVENS_VERWERKEN, this.$router)){
			throw new Error("MISSING MODULE");
		}
	},
	components: {
		AppEditBank
	},
	i18nEx: {
		componentPrefix: "components.bank"
	}
});
